import { useState } from 'react';

import { IconButton, CircularProgress } from '@mui/material';

import getCodeFile from 'services/getCodeFile';

import { CustomIcon } from 'components/UIComponents';

import { useAudioContext } from 'context/MP3Context';

import { ICodesTable } from 'interfaces/Code/ICodesTable';
import { IIsciCode } from 'interfaces/IsciCode/IIsciCode';

import { IsciCodeAPI } from 'api/isciCodeAPI';

import { LoadingBlock, StyledContainer } from './styledComponents';

interface MP3PlayBlockProps {
  code: ICodesTable;
  isciCode: IIsciCode;
  onSuccess: () => void;
}

const MP3PlayBlock = ({ code, isciCode, onSuccess }: MP3PlayBlockProps) => {
  const [audioURI, setAudioURI] = useState('');
  const {
    playAudio,
    pauseAudio,
    isPlaying,
    isLoading,
    setIsLoading,
    setSelectedAudioId,
    selectedAudioId,
  } = useAudioContext();

  const onStopClick = () => {
    pauseAudio();
  };

  const onPlayClick = () => {
    setSelectedAudioId(isciCode.id);
    setIsLoading(true);
    onStopClick();
    if (!audioURI) {
      getCodeFile(code, isciCode)
        .then((data) => {
          playAudio(data.url);
          setAudioURI(data.url);
        })
        .catch((e) => {
          setIsLoading(false);
          onSuccess();
        });
    } else {
      playAudio(audioURI);
    }
  };

  const onDeleteClick = () => {
    if (isciCode.id === selectedAudioId) onStopClick();
    IsciCodeAPI.removeFile(code.creative_id, code.id, isciCode.id).then(() => {
      onSuccess();
    });
  };

  return (
    <StyledContainer>
      {isLoading && isciCode.id === selectedAudioId ? (
        <LoadingBlock>
          <CircularProgress color="inherit" size={16} />
        </LoadingBlock>
      ) : (
        <>
          {isPlaying && isciCode.id === selectedAudioId ? (
            <IconButton onClick={onStopClick}>
              <CustomIcon size="normal" name="stop" />
            </IconButton>
          ) : (
            <IconButton onClick={onPlayClick}>
              <CustomIcon size="normal" name="play" />
            </IconButton>
          )}
        </>
      )}

      <IconButton onClick={onDeleteClick}>
        <CustomIcon size="normal" name="trash" />
      </IconButton>
    </StyledContainer>
  );
};

export default MP3PlayBlock;
